import { RsvdtlRequest } from "./reserveModel";

// 予約イシューサービス一覧取得リクエスト
export class IssueServiceRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
    }
}

// 予約利用方法一覧取得リクエスト
export class ManegmentRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
        this.IssuePk1 = rsvdtlRequest.IssuePk1;
        this.IssuePk2 = rsvdtlRequest.IssuePk2;
    }
}

// 予約利用方法一覧取得リクエスト
export class LanguagetRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
        this.CngMethodType = rsvdtlRequest.CngMethodType;
    }
}

// 予約サービス一覧取得リクエスト
export class ServiceRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest(), assignedProgram = false, used3MonthAgo = false) {
        this.Lang = lang;
        this.IssuePk1 = rsvdtlRequest.IssuePk1;
        this.IssuePk2 = rsvdtlRequest.IssuePk2;
        this.CngMethodType = rsvdtlRequest.CngMethodType;
        this.CngLanguagePk = rsvdtlRequest.CngLanguagePk;
        this.AssignedProgram = assignedProgram;
        this.Used3MonthAgo = used3MonthAgo;
    }
}

// 予約方法・施設一覧取得リクエスト
export class TabRoomRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
        this.SessionGrpPk = rsvdtlRequest.SessionGrpPk;
        this.CngMethodType = rsvdtlRequest.CngMethodType;
        this.CngLanguagePk = rsvdtlRequest.CngLanguagePk;
    }
}

// 予約カレンダー日付一覧取得リクエスト
export class CalendarDayRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest(), yearMonth = '') {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
        this.SessionGrpPk = rsvdtlRequest.SessionGrpPk;
        this.CngMethodType = rsvdtlRequest.CngMethodType;
        this.CngLanguagePk = rsvdtlRequest.CngLanguagePk;
        this.RoomPk = rsvdtlRequest.RoomPk;
        this.YearMonth = yearMonth;
    }
}
// 予約カレンダー時刻一覧取得リクエスト
export class CalendarTimeRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest(), date = '') {
        this.Lang = lang;
        this.ServicePk = rsvdtlRequest.ServicePk;
        this.SessionGrpPk = rsvdtlRequest.SessionGrpPk;
        this.CngMethodType = rsvdtlRequest.CngMethodType;
        this.CngLanguagePk = rsvdtlRequest.CngLanguagePk;
        this.RoomPk = rsvdtlRequest.RoomPk;
        this.Date = date;
    }
}

// 予約アレンジ地区一覧取得リクエスト
export class AreaRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.RegionPk = rsvdtlRequest.RegionPk;
    }
}

// 予約規定詳細取得リクエスト
export class RegulationRequest {
    constructor(lang = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.Lang = lang;
        this.RegulationPk = rsvdtlRequest.RegulationPk;
        this.RegulationHistPk = rsvdtlRequest.RegulationHistPk;
    }
}

//  セッショングループ詳細リクエスト
export class SessionGrpDetailRequest {
    constructor(rsvdtlRequest = new RsvdtlRequest()) {
        this.SessionGrpPk = rsvdtlRequest.SessionGrpPk;
    }
}




// 予約サービス詳細レスポンス
export class ServiceDetailResponse {
    constructor(ServiceId = '', ServiceNm = '', RegulationPk = '', ServiceTelMet = '', ServiceTelNum = '', ServiceGuide = '', PaymentFlag = '') {
        this.ServiceId = ServiceId;
        this.ServiceNm = ServiceNm;
        this.RegulationPk = RegulationPk;
        this.ServiceTelMet = ServiceTelMet;
        this.ServiceTelNum = ServiceTelNum;
        this.ServiceGuide = ServiceGuide;
        this.PaymentFlag = PaymentFlag;
    }
}

// 規定詳細レスポンス
export class RegulationDetailResponse {
    constructor(RegulationHistPk = '', RegulationId = '', RegulationNm = '', RegulationDt = '', RegulationContent = '') {
        this.RegulationHistPk = RegulationHistPk;
        this.RegulationId = RegulationId;
        this.RegulationNm = RegulationNm;
        this.RegulationDt = RegulationDt;
        this.RegulationContent = RegulationContent;
    }
}

// 予約イシュー一覧レスポンス
export class RsvisulstResponce {
    constructor(IssuePk, IssueId, IssueNm) {
        this.pk = IssuePk;
        this.id = IssueId;
        this.name = IssueNm;
    }

    static formApiResponse(data) {
        return new RsvisulstResponce(data.IssuePk, data.IssueId, data.IssueNm);
    }
}

// 予約利用言語一覧レスポンス
export class RsvlnglstResponce {
    constructor(CngLanguagePk, CngLanguageId, CngLanguageNm) {
        this.pk = CngLanguagePk;
        this.id = CngLanguageId;
        this.name = CngLanguageNm;
    }

    static formApiResponse(data) {
        return new RsvlnglstResponce(data.CngLanguagePk, data.CngLanguageId, data.CngLanguageNm);
    }
}

// 予約カレンダー施設一覧レスポンス
export class RsvcalromlstResponce {
    constructor(RoomPk, RoomId, RoomNm) {
        this.pk = RoomPk;
        this.id = RoomId;
        this.name = RoomNm;
    }
    static formApiResponse(data) {
        return new RsvcalromlstResponce(data.RoomPk, data.RoomId, data.RoomNm);
    }
}

// 予約アレンジ地域一覧レスポンス
export class RsvsrgrgnlstResponce {
    constructor(RegionPk, RegionId, RegionNm) {
        this.pk = RegionPk;
        this.id = RegionId;
        this.name = RegionNm;
    }
    static formApiResponse(data) {
        return new RsvsrgrgnlstResponce(data.RegionPk, data.RegionId, data.RegionNm);
    }
}

// 予約アレンジ地区一覧レスポンス
export class RsvsrgaralstResponce {
    constructor(AreaPk, AreaId, AreaNm) {
        this.pk = AreaPk;
        this.id = AreaId;
        this.name = AreaNm;
    }
    static formApiResponse(data) {
        return new RsvsrgaralstResponce(data.AreaPk, data.AreaId, data.AreaNm);
    }
}
